import useProfile from '../../store/models/profile/useProfile';

function useLoginDialog() {
    const {
        googleOauth,
        outlookOauth,
        type,
    } = useProfile();

    return {
        googleOauth,
        outlookOauth,
        type,
    };
}

export default useLoginDialog;
